<template>
	<div
			v-if="hiddenOnMobile"
			:class="['y-chat-fixed', { 'is_closed': !chatshow, 'is_hide': isClosed }]"
			:style="{ '--chat-fixed_message-status': showCount }"
	>
		<div class="y-chat-fixed__header">

			<div class="y-user y-chat-fixed__user" @click="showAndHideChat">
				<div class="y-user__head">
					<img
							v-if="teacher.banner"
							:src="teacher.banner"
							:alt="teacher.initials"
							loading="lazy"
							width="40" height="40"
							class="y-user__img"
					>
					<div v-else class="y-user__initials">{{ teacher.initials }}</div>
				</div>
				<div class="y-user__body">
					<div class="y-user__name">{{ teacher.first_name }} {{ teacher.last_name }}</div>
				</div>
			</div>

			<div class="y-chat-fixed__systems-btns">

				<button
						@click="showAndHideChat"
						type="button"
						aria-label="collapse"
						class="y-btn y-chat-fixed__systems-btn"
				>
					<span class="y-btn__icn">
						<svg width="18" height="2" viewBox="0 0 18 2" style="fill: none" xmlns="http://www.w3.org/2000/svg">
							<path d="M17 0.999999L1 1" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"/>
						</svg>
					</span>
				</button>

				<a
						href="/student/dashboard/messages"
						aria-label="expand"
						class="y-btn y-chat-fixed__systems-btn"
				>
					<span class="y-btn__icn">
						<svg width="18" height="18" viewBox="0 0 18 18" style="fill: none" xmlns="http://www.w3.org/2000/svg">
							<path d="M17 1H11.6667M17 1L9 9M17 1V6.33333" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M17 9.88889V15.2222C17 16.2041 16.2041 17 15.2222 17H2.77778C1.79594 17 1 16.2041 1 15.2222V2.77778C1 1.79594 1.79594 1 2.77778 1H8.11111" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
						</svg>
					</span>
				</a>

				<button
						@click="closeChat"
						type="button"
						aria-label="close"
						class="y-btn y-chat-fixed__systems-btn"
				>
					<span class="y-btn__icn">
						<svg width="24" height="23" viewBox="0 0 24 23" style="fill: none" xmlns="http://www.w3.org/2000/svg">
							<path d="M6.68629 5.68629L18 17" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"/>
							<path d="M6.68629 17.3137L18 6" stroke="#1E1E20" stroke-width="1.5" stroke-linecap="round"/>
						</svg>
					</span>
				</button>

			</div>

		</div>

		<div v-if="chatshow" class="y-chat-fixed__aside">

			<div
					@click="selectSystemChat()"
					:class="['y-chat-user is_small', { is_active : isActive === 'system' }]"
			>
				<div
						title="System chat"
						class="y-chat-user__thumb"
				>
					<svg width="29" height="32" viewBox="0 0 29 45" style="fill: none" xmlns="http://www.w3.org/2000/svg">
						<path
								d="M6.65 30.676c1.852.145 3.684.363 5.535.436.998.036.908.435.581 1.088h-2.105c-2.395-.218-4.79-.2-7.186-.218-.635 0-1.343.127-1.869-.417v-2.74c.653-.363 1.38-.454 2.123-.454 5.498 0 10.997.182 16.513.327.708.018 1.343-.363 1.996-.58.4-.128.69-.182 1.071.072 1.07.726 2.178 1.397 3.267 2.087.272.163.653.417.471.707-.254.418-.544-.036-.762-.181a104.967 104.967 0 01-2.976-1.96c-.4-.272-.708-.29-1.143-.072-1.905.961-3.829 1.85-5.734 2.812-.6.309-1.18.381-1.815.381-.345 0-.599 0-.635-.453-.036-.4.09-.563.454-.69 1.179-.4 2.34-.817 3.484-1.433h-4.755c-.072 0-.181-.019-.2.018-.943 1.451-2.431.562-3.647.798-.98.182-2.032.09-3.048.109-.454.29-.89.181-1.343.018.526.236 1.161.11 1.724.345 z"
								fill="#292D6E"></path>
						<path
								d="M24.76 32c-1.669-1.524-3.501-2.231-5.697-.78-.018-.109-.018-.236-.036-.345.78-.362 1.615-.67 2.34-1.125 1.035-.653 1.706.091 2.468.49.871.454 1.724.926 2.577 1.398.218.127.563.181.472.58h-.835c-.399-.308-.889 0-1.288-.217z"
								fill="#292D6E"></path>
						<path
								d="M24.76 32c.436.055.908-.199 1.29.182h-1.271c0-.073 0-.127-.018-.181zM15.107 20.35c2.178-.054 4.337.11 6.515.255.38.018.762.108 1.107.254.272.109.78.217.689.508-.109.417-.599.399-.998.272-.163-.054-.345-.073-.508-.109-.018.036-.018.073-.055.09-.326.328.472 1.217-.471 1.162-.835-.054-.2-.87-.454-1.27-.054-.09-.236-.127-.363-.127-.236-.018-.254.163-.254.345v1.143c-.726.054-.89-.309-.835-.907.037-.345.073-.744-.49-.708-.544.036-.308.417-.363.708-.054.272.273.744-.399.726-.617-.019-.454-.436-.417-.726.072-.69-.327-.726-.835-.69-.435.018-.98-.145-.853.635.055.345 0 .599-.472.599-.526 0-.58-.272-.508-.671.091-.49-.236-.581-.562-.472-.4.127-1.035-.345-1.18.435-.054.309.127.726-.472.708-.49-.018-.471-.309-.453-.635.018-.508-.345-.436-.654-.418-1.016.037-1.996.236-2.976.563-.617.218-1.379.508-1.633-.58-.09-.4-.435-.237-.707-.237-.472 0-.527.4-.672.69-.181.381.2.381.4.436.78.181-.218.471 0 .635 4.373.326 8.728.145 13.065.726-2.36.054-4.392.943-6.297 2.195l.036.018c-.254-.69-.943-1.034-.943-1.034s-.545.236-.78.871c-.073.182-.037.508-.055.726-.018.435-.09.635-.254.907-.254.4-.726.345-1.107.29-.472-.072-.327-.49-.327-.762 0-.38 0-.78.037-1.16.036-.545-.708-.999-.708-.999s-.762.454-.799.98c-.018.417-.072.835-.054 1.252.018.508-.018.835-.708.835-.707 0-.69-.363-.671-.853.018-.563 0-1.125 0-1.688 0-.399-.58-.707-.58-.707s-.636.308-.636.725c0 .6-.018 1.198 0 1.797.018.436-.127.617-.599.617-.453 0-.508-.218-.526-.58-.036-.872-.09-1.761-.182-2.632-.054-.58-.072-1.234-.852-1.397-.073-.018-.146-.037-.182-.073-.181-.181-.145-.526-.054-.562 1.052-.418-.853-1.997.834-2.142 3.72-.363 7.477.073 11.215.037 z"
								fill="#292D6E"></path>
						<path
								d="M9.137 14.852c.98-1.832 2.34-3.284 3.883-4.01-.69 2.178-1.089 4.319-1.325 6.478-.072.726-.671.272-1.016.327-.544.109-.38-.29-.308-.599a3.573 3.573 0 00-.018-1.579c-.726.254-.98.726-.998 1.361-.037.744-.49.926-1.126.762-.69-.163-.235-.671-.217-1.016 0-.29.145-.599.036-.907-1.18.345-.58 1.905-1.651 2.413 5.534.091 11.033.218 16.513 1.053-.254.562-.69.472-1.125.435-3.738-.344-7.476-.58-11.233-.562-.671 0-1.343.09-1.996.054-.69-.036-1.143.182-1.306.871a3.117 3.117 0 01-2.487 0c-.018-.308-.09-.562-.326-.834-.254-.29-.309-.817.2-.926.907-.2.816-.943.925-1.542.653-3.321 2.504-5.626 5.68-6.842.163.146.145.309.018.472-1.198 1.18-2.323 2.377-2.36 4.21-.072.381-.054.4.237.381 z"
								fill="#292D6E"></path>
						<path
								d="M11.278 10.243c0-.163-.018-.308-.018-.472.018-.308-.073-.834.127-.98.218-.145.526-.181.925-.254.11-.018.327 0 .4-.127.054-.072.054-.217.072-.345.073-.471.073-.834-.018-1.252a1.128 1.128 0 00-.054-.181c-.019-.036-.127-.073-.164-.09-.09-.055-.109-.073-.163-.128a1 1 0 01-.127-.163c-.327-.49.163-.653.671-.853.309-.127.69-.09.89-.436.072-.054.145-.036.217.019.381.435.944.308 1.416.435.363.09.69.381.598.744-.072.309-.471.127-.725.109-.527-.036-.998-.381-1.597-.163.072.308.236.635.2.925-.091.599.036.98.308 1.216.181.145.435.145 1.052.218.273.036.6.054.744.109.11.036.327.09.327.163.018.2.127.562.381.726.055.036.073.09.055.127-.019.036-.037.054-.055.054-1.905-.816-3.774-.962-5.462.6zM14.218 11.187c1.288 1.796 1.27 3.92 1.488 5.988.018.181.127.472-.218.472-.254 0-.599.109-.671-.309a4.355 4.355 0 01-.091-.834c-.036-1.779-.182-3.557-.508-5.317zM16.522 26.484c-.145.49.4 1.343-.834 1.307-1.307-.037-.69-.926-.799-1.47-.127-.654.327-1.234.817-1.234.671.018 1.089.562.816 1.397 z"
								fill="#292D6E"></path>
						<path
								d="M14.055 4.999c-.073 0-.146 0-.218-.018-.563-1.398-.6-2.759.345-4.029.163-.218.326-.236.471.018.236.472.345.926-.127 1.325-.562.49-.49.907.11 1.306.417.29.507.672-.11.726-.544.037.091.762-.471.672zM19.39 24.996c.344.762.326 1.452.344 2.141.018.472-.09.744-.617.672-.326-.055-.889.163-.943-.164-.091-.508-.127-1.125.236-1.596.272-.363.598-.654.98-1.053zM21.857 26.793c-.108.272.218.834-.235 1.088-.218.128-.817.073-.944-.217-.2-.508-.2-1.125 0-1.634.127-.344.417-.87.835-.762.272.073.435.6.399.998 0 .127-.018.255-.055.527zM4.782 19.933h2.486c.236.4.635.218.943.218 1.924.018 3.847.018 5.77.018.382 0 .781-.054 1.126.182-3.738 0-7.476-.018-11.233-.018.218-.345.726.036.908-.4zM22.638 25.83v-1.469c0-.236-.11-.526.236-.58.272-.037.617-.146.78.108.145.2.163.472-.09.744-.654.69-.164 1.597-.4 2.377-.073.254.181.762-.309.726-.49-.036-.217-.49-.235-.762-.019-.381 0-.762 0-1.143h.018zM13.51 15.288c.563.653.726 1.415.345 2.177-.073.145-1.125-.018-1.125-.09-.073-.78-.127-1.616.78-2.087zM16.123 16.74c.018-.4-.09-1.035.436-.98.453.036.671.635.635 1.179-.037.308.181.708-.436.708-.78.018-.653-.454-.635-.908zM18.682 15.76c.526.453.708.98.635 1.596-.018.218.127.545-.309.49-.254-.018-.544-.054-.544-.363.018-.562-.163-1.16.218-1.724zM21.404 17.502c-.037.254.127.58-.29.544-.89-.073-.454-.89-.708-1.325-.145-.236.054-.707.29-.617.617.236.563.908.708 1.398zM13.02 25.922c0 .417-.018.834-.018 1.252 0 .254-.055.399-.345.399-.254 0-.4-.109-.363-.381.037-.545-.236-1.27.744-1.252l-.018-.018zM18.01 10.043c-.49-.272-.762-.399-1.252-.58a.374.374 0 000 .2c.363.217.581.362.853.562 2.777 1.742 4.537 4.119 4.736 7.494.055.89.672.436.944.508-.744-3.339-1.597-6.678-5.28-8.184zM9.137 14.852c-.018.2-.182.381-.309.236-.163-.181-.09-.454.091-.653.09.145.145.29.218.417zM4.491 44.14H4.22l-.508-1.324H1.733l-.526 1.325H.935l1.669-4.101h.272l1.615 4.1zm-1.615-3.429c-.054-.127-.09-.29-.145-.435-.054.145-.09.272-.163.417l-.762 1.923H3.62l-.744-1.905zM6.524 44.231c-1.125 0-1.87-.852-1.87-2.123 0-1.288.763-2.16 1.906-2.16.78 0 1.597.49 1.688 1.325h-.236c-.145-.67-.708-1.106-1.452-1.106-.98 0-1.651.78-1.651 1.923s.653 1.924 1.633 1.924c.907 0 1.433-.636 1.524-1.47h.236c-.073 1.016-.798 1.687-1.778 1.687zM11.968 44.14h-.273l-.508-1.324H9.21l-.526 1.325h-.272l1.67-4.101h.272l1.615 4.1zm-1.615-3.429c-.055-.127-.091-.29-.146-.435-.054.145-.09.272-.163.417l-.762 1.923h1.815l-.744-1.905zM13.655 40.04c1.234 0 1.87.78 1.87 1.996 0 1.197-.545 2.123-1.87 2.123h-1.397v-4.101h1.397v-.018zm-1.143 3.883h1.053c1.252 0 1.705-.762 1.705-1.87 0-1.052-.49-1.777-1.633-1.777h-1.125v3.647zM18.845 40.257h-2.522v1.634h2.359v.217h-2.36v1.797h2.541v.218H16.07v-4.101h2.776v.235zM23.273 44.14h-.254v-3.066c0-.272.018-.526.036-.798-.072.163-.109.326-.181.49l-1.452 3.393h-.236l-1.452-3.34c-.072-.162-.127-.344-.181-.507.018.272.036.526.036.78v3.067h-.236v-4.101h.345c.345.816 1.307 3.048 1.307 3.048.2.472.326.799.326.799s.11-.29.29-.726c0 0 .944-2.214 1.325-3.121h.345v4.083h-.018zM25.396 42.435v1.706h-.254v-1.706l-1.651-2.395h.308l1.307 1.887c.054.09.127.181.181.29.055-.09.109-.181.182-.272l1.324-1.905h.29l-1.687 2.395 z"
								fill="#292D6E"></path>
						<path
								d="M4.419 37.354c0-.381-.454-.472-1.016-.508-1.198-.091-1.997-.49-2.015-1.706-.054-2.395 4.247-2.395 4.228 0H4.274c0-.744-1.488-.671-1.543-.018-.036.417.381.508.871.562 1.107.127 2.178.29 2.178 1.67 0 2.323-4.5 2.359-4.482-.073h1.36c.037.708 1.76.726 1.76.073zM6.288 34.723v-1.27h4.12v1.27H9.045v4.264H7.65v-4.264H6.288zM14.254 37.118v-3.666h1.343v3.684c0 1.216-1.053 1.924-2.196 1.924-1.125 0-2.195-.708-2.195-1.924v-3.684h1.342v3.666c0 .454.436.671.853.671.436 0 .853-.217.853-.671zM19.081 38.987h-2.087v-5.535h2.087c3.593.019 3.593 5.517 0 5.535zm-.69-1.288h.672c1.76 0 1.76-2.958 0-2.958h-.671v2.958 z"
								fill="#CD141F"></path>
						<path
								d="M24.96 38.987h-1.397v-2.323l-1.85-2.994v-.218h1.524l.998 1.851h.054l.998-1.85h1.543v.217l-1.87 2.994v2.323 z"
								fill="#CD141F"></path>
					</svg>
					<div
							v-if="getCount('system') > 0"
							class="y-chat-user__total"
					>{{ getCount('system') }}
					</div>
				</div>
			</div>

			<div
					@click="selectTeacherSystemChat(teacher)"
					:class="['y-chat-user is_small', { is_active : isActive === 0 + '_system' }]"
			>
				<div class="y-chat-user__thumb is_group">
					<img
							v-if="teacher.banner"
							:src="teacher.banner"
							:alt="teacher.initials"
							:title="teacher.first_name + ' ' + teacher.last_name"
							loading="lazy"
							width="40" height="40"
							class="y-chat-user__img"
					>

					<div
							v-else
							class="y-chat-user__initials"
					>{{ teacher.initials }}</div>

					<div
							v-for="group in teacher.groups"
							:title="'Група: ' + group.name"
							class="y-chat-user__group"
					>гр</div>

					<div
							v-if="getCount(0 + '_system') > 0"
							class="y-chat-user__total"
					>{{ getCount(0 + '_system') }}</div>

				</div>
			</div>

			<div
					@click="selectChat(teacher)"
					:class="['y-chat-user is_small', { is_active : isActive === 0 }]"
			>
				<div class="y-chat-user__thumb">
					<img
							v-if="teacher.banner"
							:src="teacher.banner"
							:alt="teacher.initials"
							:title="teacher.first_name + ' ' + teacher.last_name"
							loading="lazy"
							width="40" height="40"
							class="y-chat-user__img"
					>

					<div v-else class="y-chat-user__initials">{{ teacher.initials }}</div>

					<div
							v-if="getCount(0) > 0"
							class="y-chat-user__total"
					>{{ getCount(0) }}</div>
				</div>
			</div>

		</div>

		<div v-if="chatshow" class="y-chat-fixed__main">

			<button
					v-if="next_page_url"
					ref="js_btnShowMore"
					@click="load_next"
					type="button"
					class="y-btn y-btn_main y-chat-fixed__btn-show"
			>
				<span class="y-btn__txt">{{ $t('show_more') }}</span>
			</button>

			<div class="y-chat-fixed__window">
				<ChatMessageComponent
						:messages="messages"
						:class="{'no_field': isSystem()}"
						ref="scroll"
				/>
			</div>


			<ChatComponent
					v-if="!isSystem()"
					:messages="messages"
					@sendMessage="onClickSendMessage"
					class="y-chat-fixed__field"
			/>

		</div>

	</div>
</template>

<script>
import ChatComponent from "./ChatComponent";
import ChatMessageComponent from "./ChatMessageComponent";

export default {
	name: "StudentChatWrapperComponentFooter",
	components: {
		ChatComponent,
		ChatMessageComponent
	},
	props: [ 'chatshow' ],
	data() {
		return {
			isActive: false,
			isClosed: false,
			count_unread: false,
			hiddenOnMobile: false,

			teachers: '',
			groups: '',
			student: '',
			system: '',
			group_ids: '',
			academies: '',

			channels: [],
			messages: [],
			teacher: '',
			group: '',

			next_page_url: '',
			prev_page_url: '',

			all_chats: [{ 'chat': 'system' }]
		}
	},

	computed: {
		showCount() {
			if (this.$root.storage.global_count > 0) {
				return "block"
			} else {
				return "none"
			}
		},
	},
	methods: {

		showAndHideChat() {
			this.$root.$emit('chatShow', !this.chatshow)

		},

		closeChat() {
			this.isClosed = true
			this.$root.$emit('chatShow', false)
			$('.y-main__inner').addClass('is_close-chat')
		},

		async getTeachersData() {
			try {
				const { data: { teachers }} = await axios.get('/chat/getDataForFooter')
                if (teachers && teachers[0]) {
                    this.teacher = teachers[0]
                }
			} catch (e) {
				console.error(e)
			}
		},

		async getInitFooterData() {
			try {
				const {
					data: {
						teachers,
						student,
						group_ids,
						group,
						groups,
						academies
					}
				} = await axios.get('/chat/getDataForFooter')

				this.teachers = teachers
				this.student = student
				this.group_ids = group_ids
				this.group = group
				this.groups = groups
				this.academies = academies
				await this.afterGetDate()

			} catch (e) {
				console.error(e)
			}
		},

		async afterGetDate() {
			this.teacher = this.teachers[0];
			// this.isActive = 0;
			await axios({
				url: '/chat/getChatHistory',
				method: 'post',
				data: {
					'teacher_email': this.teacher.email,
					'student_email': this.student.email,
				}
			})
					.then((response) => {
						this.$root.storage.global_count = response.data.new_count;
						console.log('afterGetDate response', response.data.messages.data)
						this.messages = response.data.messages.data;
						this.messages.reverse()
						this.next_page_url = response.data.messages.next_page_url
					})
					.catch((error) => {
						reject(error)
					})


			window.Echo.leave(this.channel)
			window.Echo.channel(this.teacher.email + '.' + this.student.email).listen('PrivateChat', ({ data }) => {
				console.log('afterGetDate', data.message)
				this.messages.push(data.message);
			})
			this.channel = this.teacher.email + '.' + this.student.email;

		},

		/*load_next() {
			this.teacher = this.teachers[0];
			this.isActive = 0;
			axios({
				url: this.next_page_url,
				method: 'post',
				data: {
					'teacher_email': this.teacher.email,
					'student_email': this.student.email,
				}
			})
					.then((response) => {

						console.log('load_next response', response)

						this.$root.storage.global_count = response.data.new_count;

						for (let i = 0; i < response.data.messages.data.length; i++) {
							this.messages.unshift(response.data.messages.data[i])
						}
						this.next_page_url = response.data.messages.next_page_url
						// this.hasScroll()
					})
					.catch((error) => {
						reject(error)
					})
			window.Echo.leave(this.channel);
			window.Echo.channel(this.teacher.email + '.' + this.student.email).listen('PrivateChat', ({ data }) => {// this.messages = [...this.messages, data.message];
				this.messages.push(data.message);
				console.log('load_next', data.message)
			})
			this.channel = this.teacher.email + '.' + this.student.email;
		},*/
		load_next() {
			let data_request;
			if (this.isActive === 'system') {
				data_request = {
					'group_ids': this.group_ids,
				};

				const main_this = this;

				$.each(this.group_ids, function (index, value) {
					window.Echo.channel('system-group.' + value + '.' + main_this.student.email).listen('SystemChat', ({ data }) => {
						main_this.messages.push(data);
						this.countMessagesUnread()
					});
					main_this.channels.push('system-group.' + value + '.' + main_this.student.email);
				});
			} else {
				this.teacher = this.teachers[this.isActive.toString().replace('_system', '')];
				data_request = {
					'teacher_id': this.teacher.id,
					'teacher_email': this.teacher.email,
					'student_email': this.student.email,
					'group_ids': this.group_ids,
				};

				window.Echo.leave(this.channel);
				window.Echo.channel(this.teacher.email + '.' + this.student.email).listen('PrivateChat', ({ data }) => {
					this.messages.push(data.message);
					this.countMessagesUnread()
					console.log('load_next', data.message)
				})
				this.channel = this.teacher.email + '.' + this.student.email;
			}

			axios({
				url: this.next_page_url,
				method: 'post',
				data: data_request,
			}).then((response) => {
				this.$root.storage.global_count = response.data.new_count;

				for (let i = 0; i < response.data.messages.data.length; i++) {
					this.messages.unshift(response.data.messages.data[i])
				}
				this.next_page_url = response.data.messages.next_page_url
			}).catch((error) => {
				reject(error)
			})

		},
		selectSystemChat() {
			this.isActive = 'system';

			axios({
				url: '/chat/getChatSystemHistory',
				method: 'post',
				data: {
					'group_ids': this.group_ids,
				}
			}).then((response) => {
				this.$root.storage.global_count = response.data.new_count;
				this.messages = response.data.messages.data;
				this.messages.reverse()
				this.next_page_url = response.data.messages.next_page_url
				this.countMessagesUnread()
			}).catch((error) => {
				reject(error)
			})

			const main_this = this;

			$.each(this.channels, function (index, value) {
				window.Echo.leave(value);
			});

			$.each(this.academies, function (index, value) {
				window.Echo.channel('system-academy.' + value + '.' + main_this.student.email).listen('SystemChat', ({ data }) => {
					main_this.messages.push(data);
					this.countMessagesUnread()
				});
				main_this.channels.push('system-academy.' + value + '.' + main_this.student.email);
			});

			window.Echo.channel('system').listen('SystemChat', ({ data }) => {
				this.messages.push(data);
				this.countMessagesUnread()
			});
			this.channels.push('system');

			$.each(this.group_ids, function (index, value) {
				window.Echo.channel('system-group.' + value + '.' + main_this.student.email).listen('SystemChat', ({ data }) => {
					main_this.messages.push(data);
					this.countMessagesUnread()
				});
				main_this.channels.push('system-group.' + value + '.' + main_this.student.email);
			});

		},

		selectTeacherSystemChat(teacher) {

			this.isActive = 0 + '_system';

			this.teacher = this.teachers[0];
			axios({
				url: '/chat/getChatTeacherSystemHistory',
				method: 'post',
				data: {
					'teacher_id': this.teacher.id,
					'student_email': this.student.email,
					'group_ids': this.group_ids,
				}
			}).then((response) => {
				this.$root.storage.global_count = response.data.new_count;
				this.messages = response.data.messages.data;
				this.messages.reverse();
				this.next_page_url = response.data.messages.next_page_url
				this.countMessagesUnread()
			}).catch((error) => {
				reject(error)
			});

			$.each(this.channels, function (index, value) {
				window.Echo.leave(value);
			});

			window.Echo.channel('system.' + this.teacher.email + '.' + this.student.email).listen('PrivateChat', ({ data }) => {
				this.messages.push(data.message);
				this.countMessagesUnread()
			});
			this.channels.push('system.' + this.teacher.email + '.' + this.student.email);

		},

		selectChat() {
			this.isActive = 0;
			this.teacher = this.teachers[0]
			axios({
				url: '/chat/getChatHistory',
				method: 'post',
				data: {
					'teacher_email': this.teacher.email,
					'student_email': this.student.email,
				}
			}).then((response) => {
				this.$root.storage.global_count = response.data.new_count;
				this.messages = response.data.messages.data;
				this.messages.reverse();
				this.next_page_url = response.data.messages.next_page_url
				this.countMessagesUnread()
			}).catch((error) => {
				reject(error)
			});

			$.each(this.channels, function (index, value) {
				window.Echo.leave(value);
			});

			window.Echo.channel(this.teacher.email + '.' + this.student.email).listen('PrivateChat', ({ data }) => {
				this.messages.push(data.message);
				console.log('selectChat', data.message)
				this.hasScroll()
				this.countMessagesUnread()

			});
			this.channels.push(this.teacher.email + '.' + this.student.email);

		},

		countMessagesUnread() {

			this.all_chats = [ { 'chat': 'system' } ];
			let this_parent = this;

			$.each(this.teachers, function (index, value) {
				this_parent.all_chats.push({
					'chat': index,
					'teacher_id': value.id,
					'student_email': this_parent.student.email
				})
				this_parent.all_chats.push({
					'chat': index + '_system',
					'teacher_id': value.id,
					'student_email': this_parent.student.email
				})
			});

			axios({
				url: '/chat/countMessages',
				method: 'post',
				data: {
					'group_ids': this.group_ids,
					'chats': this_parent.all_chats,
				}
			}).then((response) => {
				this.hasScroll()
				this.count_unread = response.data.unread;

			}).catch((error) => {
				reject(error)
			})

		},

		isSystem() {
			if (this.isActive.toString()) {
				this.no_chat = this.isActive.toString().indexOf('system') > -1;
				return this.isActive.toString().indexOf('system') > -1;
			}
		},

		getCount(index) {
			if (this.count_unread[index]) {
				return this.count_unread[index];
			}
			return ''
		},

		onClickSendMessage(data) {
			return new Promise((resolve, reject) => {
				axios({
					url: '/chat',
					method: 'POST',
					data: {
						'message': this.student.first_name + ': ' + data.message,
						'user': this.student,
						'teacher': this.teacher.email,
					}
				})
						.then((response) => {})
						.catch((error) => {
							reject(error)
						})
			})
		},

		hasScroll() {
			const div = this.$refs.scroll.$el
			let is_scroll
			is_scroll = div.scrollHeight > div.clientHeight && !(div.style.overflow && div.style.overflow === 'hidden')
			is_scroll ? div.parentNode.classList.add('is_scroll') : div.parentNode.classList.remove('is_scroll')

			$(div).resize(() => {
				is_scroll = div.scrollHeight > div.clientHeight && !(div.style.overflow && div.style.overflow === 'hidden')
				is_scroll ? div.parentNode.classList.add('is_scroll') : div.parentNode.classList.remove('is_scroll')
			})

			div.scrollTop = div.scrollHeight

		},
		hiddenChatOnMobile() {
			this.hiddenOnMobile = window.matchMedia('(min-width: 1280px)').matches;
		}
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.hiddenChatOnMobile);
	},
	async mounted() {
		this.hiddenChatOnMobile()
		window.addEventListener("resize", this.hiddenChatOnMobile);
		this.isActive = 0;
		await this.getTeachersData()
		this.$root.$on('chatShow', async (payload) => {
			if (payload === true) {
				this.isClosed = false
				await this.getInitFooterData()
				await this.countMessagesUnread()
			}
		})
	}
}
</script>

<style scoped>
</style>
